export class AppPortal {
  IdPortal?: number;
  name?: string;
  title?: string;
  configuration?: string;
}
